<template>
  <div class="wrapper">
    <Heroheader />
    <Pickup />
    <HeaderBannar />
    <TopContact />
    <Lineup />
    <section id="productwrap">
      <Product locate="jikiba5" id="jikiba5a" />
      <Product locate="jikiba5" id="jikiba5b" />
      <Product locate="jikiba5" id="jikiba5c" />
      <Product locate="jikiba5" id="jikiba5d" />
      <BunjoInfo locate="jikiba_info" />
    </section>
    <Works />
  </div>
</template>

<script>
import Heroheader from "@/components/HeroHeader.vue";
import HeaderBannar from "@/components/HeaderBannar.vue";
import Pickup from "@/components/Parts24Springcampaign.vue";
import Lineup from "@/components/PartsLineup.vue";
import Product from "@/components/CpProduct.vue";
import BunjoInfo from "@/components/PartsBunjoInfo.vue";
import Works from "@/components/PartsWorks.vue";
import TopContact from "@/components/PartsTopContact.vue";

export default {
  name: "HomeView",
  components: {
    Heroheader,
    HeaderBannar,
    Pickup,
    Lineup,
    Product,
    BunjoInfo,
    Works,
    TopContact,
  },
};
</script>
<style lang="scss" scoped>
#productwrap {
  padding-bottom: $v-gap;
}
</style>
